import type { SlideData } from "@/types/lesson";
import { ContentSlide } from "./ContentSlide";
import { QuizSlide } from "./QuizSlide";
import { SpeakSlide } from "./SpeakSlide";

interface SlideRendererProps {
  slide: SlideData;
  slideIndex: number;
  isChildTheme: boolean;
  onQuizCorrect?: () => void;
  isQuizAnswered?: boolean;
}

export function SlideRenderer({
  slide,
  slideIndex,
  isChildTheme,
  onQuizCorrect,
}: SlideRendererProps) {
  if (slide.type === "content") {
    return <ContentSlide slide={slide} bannerIndex={slideIndex} isChildTheme={isChildTheme} />;
  }
  if (slide.type === "quiz") {
    return (
      <QuizSlide
        slide={slide}
        onCorrect={onQuizCorrect ?? (() => {})}
        isChildTheme={isChildTheme}
      />
    );
  }
  if (slide.type === "speak") {
    return <SpeakSlide slide={slide} />;
  }
  return null;
}
